import styled from 'styled-components/macro'

import { lighten } from 'polished'

const ProductDescription = styled.p`
  color: ${props =>
    props.theme.productName && lighten(0.3, props.theme.productName)};
  font-size: 1rem;
`
export default ProductDescription
